import { createSelector } from "reselect";

import batman from "./batman";

export const ThemeEnum = {
  DEFAULT: "Default",
  BATMAN: "Batman",
};

export const COLOR_THEMES = [ThemeEnum.DEFAULT, ThemeEnum.BATMAN];

// actions
export const setColorTheme = colorTheme => {
  window.localStorage.setItem("colorTheme", colorTheme);
};

// selectors
export const getColorTheme = () =>
  window.localStorage.getItem("colorTheme") || ThemeEnum.DEFAULT;

export const getThemeFile = createSelector([getColorTheme], theme => {
  return selectThemeFile(theme);
});

// helpers
export const selectThemeFile = theme => {
  switch (theme) {
    case ThemeEnum.BATMAN:
      return batman;
    default:
      return {};
  }
};
